// A (board class × promotion group) pair identifies one Evo room card (MPH-652): rates that differ
// by a benefit belong to different cards, so any rate lookup made on behalf of a card — cancellation
// options, bed variants, option counts — must stay inside the card's group. Matching a rate of another
// group would silently swap the benefit the card advertises.

// promotionKey is absent when a rate has no promotions; normalise so absent and empty compare equal.
export const getPromotionGroupKey = (mealPlan: MealPlanType): string => mealPlan.promotionKey || '';

// The rates belonging to the same card as the anchor rate.
export function getPromotionGroupMealPlans(
  configurations: readonly MealPlanType[],
  anchorMealPlan: MealPlanType
): MealPlanType[] {
  return configurations.filter(
    (mealPlan) =>
      mealPlan.boardClass === anchorMealPlan.boardClass &&
      getPromotionGroupKey(mealPlan) === getPromotionGroupKey(anchorMealPlan)
  );
}
